import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class CreateKundorderCommand extends BasicCommand<CreateKundorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<CreateKundorderCommand>;

    Kundordertyp: string;
    kundId: number;
    mattslag: string;
    avtalansvarigId: number;
    beskrivning: string;

    // Kundorderrad
    kvantitet: number;
    lagerplatser: number[];
    handelssortimentId: number;
    mottagningsplatsId: number;
    periodFrom: string;
    periodTom: string;
    manuellPaArbetsorder: boolean;
    egenskapskodX: boolean;
    ejVirkeskop: boolean;

    constructor(kundordertyp: string) {
        super("CreateKundorderCommand", "kundorder", CommandType.Insert);
        this.Kundordertyp = kundordertyp;
    }

}
